import { BehaviorSubject } from "rxjs";
import { MEGDataService } from "./meg-data.service";
import { DMVStoreService } from "./../dmv/dmv-store.service";
import { AppUtil } from "./../../utils/app.util";
import * as i0 from "@angular/core";
import * as i1 from "./meg-data.service";
import * as i2 from "../dmv/dmv-store.service";
export class MEGStoreService {
    constructor(megDataService, dmvStoreService) {
        this.megDataService = megDataService;
        this.dmvStoreService = dmvStoreService;
        this._configuration = new BehaviorSubject(null);
        // Expose the observable$ (read only stream)
        this.configurations$ = this._configuration.asObservable();
        // Data access by consumers
        this.configurationsData$ = this.configurations$;
    }
    // The getter will return the last value emitted
    get configuration() {
        return this._configuration.getValue();
    }
    // Assigning a value will push it onto the observable
    set configuration(val) {
        this._configuration.next(val);
    }
    getConfigurations(appType, entryPointID, token) {
        this.megDataService
            .getConfigurationResponse(appType, entryPointID, token)
            .subscribe(megResponse => {
            if (megResponse) {
                this.configuration = megResponse;
                AppUtil.log("MEGStoreService megResponse =>", this.configuration);
            }
        }, error => {
            error.status = 408;
            this.configuration = error;
        });
    }
}
MEGStoreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MEGStoreService_Factory() { return new MEGStoreService(i0.ɵɵinject(i1.MEGDataService), i0.ɵɵinject(i2.DMVStoreService)); }, token: MEGStoreService, providedIn: "root" });
